import { render, staticRenderFns } from "./VehiclesData.vue?vue&type=template&id=0d8fbcfe&"
import script from "./VehiclesData.vue?vue&type=script&lang=js&"
export * from "./VehiclesData.vue?vue&type=script&lang=js&"
import style0 from "./VehiclesData.vue?vue&type=style&index=0&id=0d8fbcfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports